import React from 'react';
import { cn } from '../lib/utils';

interface Tab<T extends string> {
  value: T;
  label: string;
  icon?: React.ReactNode;
}

interface TabSelectorProps<T extends string> {
  tabs: Tab<T>[];
  value: T;
  onChange: (value: T) => void;
  className?: string;
}

export function TabSelector<T extends string>({
  tabs,
  value,
  onChange,
  className,
}: TabSelectorProps<T>) {
  return (
    <div className={cn('inline-flex p-0.75 rounded-lg bg-surface-light-pro', className)}>
      {tabs.map(tab => (
        <button
          key={tab.value}
          onClick={() => onChange(tab.value)}
          className={cn(
            'flex items-center gap-2 px-4 py-2 rounded-md text-sm font-regular transition-colors',
            value === tab.value
              ? 'bg-white text-primary-brown font-semibold'
              : 'text-text-secondary hover:bg-white'
          )}
        >
          {tab.icon}
          {tab.label}
        </button>
      ))}
    </div>
  );
}
